import { jsx } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import { useTheme } from "@mui/material/styles";
const StageEnd = (t0)=>{
    const $ = c(6);
    const { last, status } = t0;
    const { tokens } = useTheme();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ jsx("path", {
            d: "M0 0H4C8.41828 0 12 3.58172 12 8V16C12 20.4183 8.41828 24 4 24H0V0Z"
        });
        $[0] = t1;
    } else t1 = $[0];
    const rounded = t1;
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ jsx("path", {
            d: "M0 0H0.126542C1.31366 0 2.43945 0.527292 3.19943 1.43926L7.73215 6.87853C10.2045 9.84529 10.2045 14.1547 7.73215 17.1215L3.19942 22.5607C2.43945 23.4727 1.31366 24 0.126542 24H0V0Z"
        });
        $[1] = t2;
    } else t2 = $[1];
    const angled = t2;
    const t3 = "initial" === status ? tokens.colors.bg.greyscale.primary : tokens.colors.original.brand.primary;
    const t4 = "active" === status ? 0.6 : 1;
    const t5 = last ? rounded : angled;
    let t6;
    if ($[2] !== t3 || $[3] !== t4 || $[4] !== t5) {
        t6 = /*#__PURE__*/ jsx("svg", {
            width: "12",
            height: "24",
            viewBox: "0 0 12 24",
            fill: t3,
            fillOpacity: t4,
            xmlns: "http://www.w3.org/2000/svg",
            children: t5
        });
        $[2] = t3;
        $[3] = t4;
        $[4] = t5;
        $[5] = t6;
    } else t6 = $[5];
    return t6;
};
export { StageEnd };
